import React from "react";
import AdminLayout from "@/components/AdminLayout";
import { useLocation, Link } from "react-router-dom";
import { Construction } from "lucide-react";

// Generic placeholder for admin sidebar items whose full UI ships in later phases.
// Keeps navigation intact and clearly signals scope.
const AdminPlaceholder = ({ title, description, phase = "next phase" }) => {
  const location = useLocation();
  return (
    <AdminLayout title={title}>
      <div className="border border-border bg-card p-12 text-center max-w-2xl mx-auto" data-testid="admin-placeholder">
        <Construction className="mx-auto text-accent" size={28} />
        <div className="overline text-accent mt-4">Coming soon</div>
        <h2 className="font-display text-3xl mt-3">{title}</h2>
        <p className="text-muted-foreground mt-4">
          {description || "This module is scaffolded and will ship in the next phase of the admin dashboard rollout."}
        </p>
        <div className="text-xs text-muted-foreground mt-6">
          Planned for {phase} · <code className="text-accent">{location.pathname}</code>
        </div>
        <Link to="/admin/dashboard" className="inline-block mt-6 border border-accent text-accent px-6 py-3 hover:bg-accent hover:text-accent-foreground transition-colors" data-testid="placeholder-back-dashboard">
          Back to dashboard
        </Link>
      </div>
    </AdminLayout>
  );
};

export default AdminPlaceholder;
